import $ from 'jquery';

function NaviCtrl() {
	this.$win      = $(window);
	this.$htmlBody = $('html, body');
	this.$body     = $('body');
	this.$target   = $('#nav');
	this.$btnOpen  = $('.btn-menu');
	this.$btnClose = $('#naviClose');
	this.$content = $('#main');

	this.scrollState = 0;

	this.open  = this.open.bind(this);
	this.close = this.close.bind(this);
	this.closeDocument = this.closeDocument.bind(this);

	this.init();
}

NaviCtrl.prototype.init = function() {
	const self = this;
	this.$btnOpen.on('click', this.open);
	this.$btnClose.on('click', this.close);
	this.$target.find('.nav-list a').on('click', this.close);
	$('#appWrapper').on('click', this.closeDocument);
	$('.btn-menu, #nav').on('click', function (e) {
		e.stopPropagation();
	});
}

NaviCtrl.prototype.open = function() {
	let scrollTop = this.$win.scrollTop();
	scrollCache = scrollTop;
	this.scrollState = scrollTop;
	this.$htmlBody.addClass('nav-opened');
	this.$target.addClass('nav-opened');
	this.$content.css('transform', `translateY(-${scrollTop}px)`);
}

NaviCtrl.prototype.close = function() {
	this.$htmlBody.removeClass('nav-opened');
	this.$target.removeClass('nav-opened');

	this.$win.scrollTop(this.scrollState);
	this.$content.css('transform', 'translateY(0px)');
}

NaviCtrl.prototype.closeDocument = function () {
	this.$htmlBody.removeClass('nav-opened');
	this.$target.removeClass('nav-opened');
}

export default NaviCtrl;